var Afghanistan = "阿富汗";
var Albania = "阿爾巴尼亞";
var Algeria = "阿爾及利亞";
var Andorra = "安道爾";
var Angola = "安哥拉";
var Anguilla = "安圭拉";
var Antarctica = "南極洲";
var Argentina = "阿根廷";
var Armenia = "亞美尼亞";
var Aruba = "阿魯巴";
var Australia = "澳洲";
var Austria = "奧地利";
var Azerbaijan = "亞塞拜然";
var Bahamas = "巴哈馬";
var Bahrain = "巴林";
var Bangladesh = "孟加拉";
var Barbados = "巴貝多";
var Belarus = "白俄羅斯";
var Belgium = "比利時";
var Belize = "貝里斯";
var Benin = "貝南";
var Bermuda = "百慕達";
var Bhutan = "不丹";
var Bolivia = "玻利維亞";
var Botswana = "波札那";
var Brazil = "巴西";
var Bulgaria = "保加利亞";
var Burundi = "蒲隆地";
var Cambodia = "柬埔寨";
var Cameroon = "喀麥隆";
var Canada = "加拿大";
var Chad = "查德";
var Chile = "智利";
var China = "中國";
var Colombia = "哥倫比亞";
var Comoros = "葛摩";
var Congo = "剛果";
var Croatia = "克羅埃西亞";
var Cuba = "古巴";
var Cyprus = "賽普勒斯";
var Denmark = "丹麥";
var Djibouti = "吉布地";
var Dominica = "多米尼克";
var Ecuador = "厄瓜多爾";
var Egypt = "埃及";
var Eritrea = "厄利垂亞";
var Estonia = "愛沙尼亞";
var Ethiopia = "衣索比亞";
var Fiji = "斐濟";
var Finland = "芬蘭";
var France = "法國";
var Gabon = "加彭";
var Gambia = "甘比亞";
var Georgia = "喬治亞";
var Germany = "德國";
var Ghana = "迦納";
var Gibraltar = "直布羅陀";
var Greece = "希臘";
var Greenland = "格陵蘭";
var Grenada = "格瑞那達";
var Guadeloupe = "瓜德羅普";
var Guam = "關島";
var Guatemala = "瓜地馬拉";
var Guernsey = "耿西島";
var Guinea = "幾內亞";
var Guyana = "圭亞那";
var Haiti = "海地";
var Honduras = "洪都拉斯";
var Hungary = "匈牙利";
var Iceland = "冰島";
var India = "印度";
var Indonesia = "印尼";
var Iraq = "伊拉克";
var Ireland = "愛爾蘭";
var Israel = "以色列";
var Italy = "義大利";
var Jamaica = "牙買加";
var Japan = "日本";
var Jersey = "澤西島";
var Jordan = "約旦";
var Kazakhstan = "哈薩克";
var Kenya = "肯亞";
var Kiribati = "吉里巴斯";
var Kuwait = "科威特";
var Kyrgyzstan = "吉爾吉斯";
var Latvia = "拉脫維亞";
var Lebanon = "黎巴嫩";
var Lesotho = "賴索托";
var Liberia = "賴比瑞亞";
var Libya = "利比亞";
var Liechtenstein = "列支敦斯登";
var Lithuania = "立陶宛";
var Luxembourg = "盧森堡";
var Macao = "澳門特別行政區";
var Madagascar = "馬達加斯加";
var Malawi = "馬拉威";
var Malaysia = "馬來西亞";
var Maldives = "馬爾地夫";
var Mali = "馬利";
var Malta = "馬爾他";
var Martinique = "馬丁尼克";
var Mauritania = "茅利塔尼亞";
var Mauritius = "模里西斯";
var Mayotte = "馬約特島";
var Mexico = "墨西哥";
var Monaco = "摩納哥";
var Mongolia = "蒙古";
var Montenegro = "蒙特內哥羅";
var Montserrat = "蒙特色拉特島";
var Morocco = "摩洛哥";
var Mozambique = "莫三比克";
var Myanmar = "緬甸";
var Namibia = "納米比亞";
var Nauru = "諾魯";
var Nepal = "尼泊爾";
var Netherlands = "荷蘭";
var Nicaragua = "尼加拉瓜";
var Niger = "尼日";
var Nigeria = "奈及利亞";
var Niue = "紐埃";
var Norway = "挪威";
var Oman = "阿曼";
var Pakistan = "巴基斯坦";
var Palau = "帛琉";
var Panama = "巴拿馬";
var Paraguay = "巴拉圭";
var Peru = "祕魯";
var Philippines = "菲律賓";
var Pitcairn = "皮特凱恩群島";
var Poland = "波蘭";
var Portugal = "葡萄牙";
var Qatar = "卡達";
var Romania = "羅馬尼亞";
var Rwanda = "盧安達";
var Samoa = "薩摩亞";
var Senegal = "塞內加爾";
var Serbia = "塞爾維亞";
var Seychelles = "塞席爾";
var Singapore = "新加坡";
var Slovakia = "斯洛伐克";
var Slovenia = "斯洛維尼亞";
var Somalia = "索馬利亞";
var Spain = "西班牙";
var Sudan = "蘇丹";
var Suriname = "蘇利南";
var Swaziland = "史瓦濟蘭";
var Sweden = "瑞典";
var Switzerland = "瑞士";
var Taiwan = "台灣";
var Tajikistan = "塔吉克";
var Thailand = "泰國";
var Togo = "多哥";
var Tokelau = "托克勞";
var Tonga = "東加";
var Tunisia = "突尼西亞";
var Turkey = "土耳其";
var Turkmenistan = "土庫曼";
var Tuvalu = "吐瓦魯";
var Uganda = "烏干達";
var Ukraine = "烏克蘭";
var Uruguay = "烏拉圭";
var Uzbekistan = "烏茲別克斯坦";
var Vanuatu = "萬那杜";
var Venezuela = "委內瑞拉";
var Yemen = "葉門";
var Zambia = "尚比亞";
var Zimbabwe = "辛巴威";
var countries = {
	"Country or region": "國家或地區",
	"United States": "美國",
	Afghanistan: Afghanistan,
	"Åland Islands": "奧蘭群島",
	Albania: Albania,
	Algeria: Algeria,
	"American Samoa": "美屬薩摩亞",
	Andorra: Andorra,
	Angola: Angola,
	Anguilla: Anguilla,
	Antarctica: Antarctica,
	"Antigua and Barbuda": "安地卡及巴布達",
	Argentina: Argentina,
	Armenia: Armenia,
	Aruba: Aruba,
	Australia: Australia,
	Austria: Austria,
	Azerbaijan: Azerbaijan,
	Bahamas: Bahamas,
	Bahrain: Bahrain,
	Bangladesh: Bangladesh,
	Barbados: Barbados,
	Belarus: Belarus,
	Belgium: Belgium,
	Belize: Belize,
	Benin: Benin,
	Bermuda: Bermuda,
	Bhutan: Bhutan,
	Bolivia: Bolivia,
	"Bosnia and Herzegovina": "波士尼亞與赫塞哥維納",
	Botswana: Botswana,
	"Bouvet Island": "布威島",
	Brazil: Brazil,
	"British Indian Ocean Territory": "英屬印度洋領地",
	"Brunei Darussalam": "汶萊",
	Bulgaria: Bulgaria,
	"Burkina Faso": "布吉納法索",
	Burundi: Burundi,
	Cambodia: Cambodia,
	Cameroon: Cameroon,
	Canada: Canada,
	"Cape Verde": "維德角",
	"Cayman Islands": "開曼群島",
	"Central African Republic": "中非共和國",
	Chad: Chad,
	Chile: Chile,
	China: China,
	"Christmas Island": "聖誕島",
	"Cocos (Keeling) Islands": "可可斯 (基林) 群島",
	Colombia: Colombia,
	Comoros: Comoros,
	Congo: Congo,
	"Congo, The Democratic Republic of The": "剛果民主共和國",
	"Cook Islands": "庫克群島",
	"Costa Rica": "哥斯大黎加",
	"Côte d'Ivoire": "象牙海岸",
	Croatia: Croatia,
	Cuba: Cuba,
	Cyprus: Cyprus,
	"Czech Republic": "捷克共和國",
	Denmark: Denmark,
	Djibouti: Djibouti,
	Dominica: Dominica,
	"Dominican Republic": "多明尼加共和國",
	Ecuador: Ecuador,
	Egypt: Egypt,
	"El Salvador": "薩爾瓦多",
	"Equatorial Guinea": "赤道幾內亞",
	Eritrea: Eritrea,
	Estonia: Estonia,
	Ethiopia: Ethiopia,
	"Falkland Islands (Malvinas)": "福克蘭群島 (馬爾維納斯)",
	"Faroe Islands": "法羅群島",
	Fiji: Fiji,
	Finland: Finland,
	France: France,
	"French Guiana": "法屬圭亞那",
	"French Polynesia": "法屬玻里尼西亞",
	"French Southern Territories": "法屬南部屬地",
	Gabon: Gabon,
	Gambia: Gambia,
	Georgia: Georgia,
	Germany: Germany,
	Ghana: Ghana,
	Gibraltar: Gibraltar,
	Greece: Greece,
	Greenland: Greenland,
	Grenada: Grenada,
	Guadeloupe: Guadeloupe,
	Guam: Guam,
	Guatemala: Guatemala,
	Guernsey: Guernsey,
	Guinea: Guinea,
	"Guinea-Bissau": "幾內亞比索",
	Guyana: Guyana,
	Haiti: Haiti,
	"Heard Island and McDonald Islands": "赫德島及麥克唐納群島",
	"Holy See (Vatican City State)": "教廷 (梵蒂岡)",
	Honduras: Honduras,
	"Hong Kong": "香港",
	Hungary: Hungary,
	Iceland: Iceland,
	India: India,
	Indonesia: Indonesia,
	"Iran, Islamic Republic of": "伊朗伊斯蘭共和國",
	Iraq: Iraq,
	Ireland: Ireland,
	"Isle of Man": "曼島",
	Israel: Israel,
	Italy: Italy,
	Jamaica: Jamaica,
	Japan: Japan,
	Jersey: Jersey,
	Jordan: Jordan,
	Kazakhstan: Kazakhstan,
	Kenya: Kenya,
	Kiribati: Kiribati,
	"Korea, Democratic People’s Republic of": "朝鮮民主主義人民共和國",
	"Korea, Republic of": "大韓民國",
	Kuwait: Kuwait,
	Kyrgyzstan: Kyrgyzstan,
	"Lao People's Democratic Republic": "寮國",
	Latvia: Latvia,
	Lebanon: Lebanon,
	Lesotho: Lesotho,
	Liberia: Liberia,
	Libya: Libya,
	Liechtenstein: Liechtenstein,
	Lithuania: Lithuania,
	Luxembourg: Luxembourg,
	Macao: Macao,
	"Macedonia, The Former Yugoslav Republic of": "前南斯拉夫馬其頓共和國",
	Madagascar: Madagascar,
	Malawi: Malawi,
	Malaysia: Malaysia,
	Maldives: Maldives,
	Mali: Mali,
	Malta: Malta,
	"Marshall Islands": "馬紹爾群島",
	Martinique: Martinique,
	Mauritania: Mauritania,
	Mauritius: Mauritius,
	Mayotte: Mayotte,
	Mexico: Mexico,
	"Micronesia, Federated States of": "密克羅尼西亞聯邦",
	"Moldova, Republic of": "摩爾多瓦共和國",
	Monaco: Monaco,
	Mongolia: Mongolia,
	Montenegro: Montenegro,
	Montserrat: Montserrat,
	Morocco: Morocco,
	Mozambique: Mozambique,
	Myanmar: Myanmar,
	Namibia: Namibia,
	Nauru: Nauru,
	Nepal: Nepal,
	Netherlands: Netherlands,
	"Netherlands Antilles": "荷屬安地列斯",
	"New Caledonia": "新喀里多尼亞",
	"New Zealand": "紐西蘭",
	Nicaragua: Nicaragua,
	Niger: Niger,
	Nigeria: Nigeria,
	Niue: Niue,
	"Norfolk Island": "諾褔克島",
	"Northern Mariana Islands": "北馬里安納群島",
	Norway: Norway,
	Oman: Oman,
	Pakistan: Pakistan,
	Palau: Palau,
	"Palestine, State of": "巴勒斯坦 (被占領土)",
	Panama: Panama,
	"Papua New Guinea": "巴布亞紐幾內亞",
	Paraguay: Paraguay,
	Peru: Peru,
	Philippines: Philippines,
	Pitcairn: Pitcairn,
	Poland: Poland,
	Portugal: Portugal,
	"Puerto Rico": "波多黎各",
	Qatar: Qatar,
	"Réunion": "留尼旺島",
	Romania: Romania,
	"Russian Federation": "俄羅斯聯邦",
	Rwanda: Rwanda,
	"Saint Helena": "聖赫倫那",
	"Saint Kitts and Nevis": "聖克里斯多福及尼維斯",
	"Saint Lucia": "聖露西亞",
	"Saint Pierre and Miquelon": "聖皮埃赫及密克隆",
	"Saint Vincent and The Grenadines": "聖文森及格瑞那丁",
	Samoa: Samoa,
	"San Marino": "聖馬利諾",
	"Sao Tome and Principe": "聖多美普林西比",
	"Saudi Arabia": "沙烏地阿拉伯",
	Senegal: Senegal,
	Serbia: Serbia,
	Seychelles: Seychelles,
	"Sierra Leone": "獅子山",
	Singapore: Singapore,
	Slovakia: Slovakia,
	Slovenia: Slovenia,
	"Solomon Islands": "所羅門群島",
	Somalia: Somalia,
	"South Africa": "南非",
	"South Georgia and The South Sandwich Islands": "南喬治亞島與南桑威奇群島",
	Spain: Spain,
	"Sri Lanka": "斯里蘭卡",
	Sudan: Sudan,
	Suriname: Suriname,
	"Svalbard and Jan Mayen": "冷岸和央麥恩群島",
	Swaziland: Swaziland,
	Sweden: Sweden,
	Switzerland: Switzerland,
	"Syrian Arab Republic": "敘利亞阿拉伯共和國",
	Taiwan: Taiwan,
	Tajikistan: Tajikistan,
	"Tanzania, United Republic of": "坦尚尼亞聯合共和國",
	Thailand: Thailand,
	"Timor-Leste": "東帝汶",
	Togo: Togo,
	Tokelau: Tokelau,
	Tonga: Tonga,
	"Trinidad and Tobago": "千里達及托巴哥",
	Tunisia: Tunisia,
	Turkey: Turkey,
	Turkmenistan: Turkmenistan,
	"Turks and Caicos Islands": "特克斯和凱克斯群島",
	Tuvalu: Tuvalu,
	Uganda: Uganda,
	Ukraine: Ukraine,
	"United Arab Emirates": "阿拉伯聯合大公國",
	"United Kingdom": "英國",
	"United States Minor Outlying Islands": "美國本土外小島嶼",
	Uruguay: Uruguay,
	Uzbekistan: Uzbekistan,
	Vanuatu: Vanuatu,
	Venezuela: Venezuela,
	"Viet Nam": "越南",
	"Virgin Islands, British": "英屬維京群島",
	"Virgin Islands, U.S.": "美屬維京群島",
	"Wallis and Futuna": "瓦利斯和富圖納群島",
	"Western Sahara": "西撒哈拉",
	Yemen: Yemen,
	Zambia: Zambia,
	Zimbabwe: Zimbabwe
};

export { Afghanistan, Albania, Algeria, Andorra, Angola, Anguilla, Antarctica, Argentina, Armenia, Aruba, Australia, Austria, Azerbaijan, Bahamas, Bahrain, Bangladesh, Barbados, Belarus, Belgium, Belize, Benin, Bermuda, Bhutan, Bolivia, Botswana, Brazil, Bulgaria, Burundi, Cambodia, Cameroon, Canada, Chad, Chile, China, Colombia, Comoros, Congo, Croatia, Cuba, Cyprus, Denmark, Djibouti, Dominica, Ecuador, Egypt, Eritrea, Estonia, Ethiopia, Fiji, Finland, France, Gabon, Gambia, Georgia, Germany, Ghana, Gibraltar, Greece, Greenland, Grenada, Guadeloupe, Guam, Guatemala, Guernsey, Guinea, Guyana, Haiti, Honduras, Hungary, Iceland, India, Indonesia, Iraq, Ireland, Israel, Italy, Jamaica, Japan, Jersey, Jordan, Kazakhstan, Kenya, Kiribati, Kuwait, Kyrgyzstan, Latvia, Lebanon, Lesotho, Liberia, Libya, Liechtenstein, Lithuania, Luxembourg, Macao, Madagascar, Malawi, Malaysia, Maldives, Mali, Malta, Martinique, Mauritania, Mauritius, Mayotte, Mexico, Monaco, Mongolia, Montenegro, Montserrat, Morocco, Mozambique, Myanmar, Namibia, Nauru, Nepal, Netherlands, Nicaragua, Niger, Nigeria, Niue, Norway, Oman, Pakistan, Palau, Panama, Paraguay, Peru, Philippines, Pitcairn, Poland, Portugal, Qatar, Romania, Rwanda, Samoa, Senegal, Serbia, Seychelles, Singapore, Slovakia, Slovenia, Somalia, Spain, Sudan, Suriname, Swaziland, Sweden, Switzerland, Taiwan, Tajikistan, Thailand, Togo, Tokelau, Tonga, Tunisia, Turkey, Turkmenistan, Tuvalu, Uganda, Ukraine, Uruguay, Uzbekistan, Vanuatu, Venezuela, Yemen, Zambia, Zimbabwe, countries as default };
